import { render, staticRenderFns } from "./Capillaries.vue?vue&type=template&id=5eaf2062&scoped=true&"
import script from "./Capillaries.vue?vue&type=script&lang=js&"
export * from "./Capillaries.vue?vue&type=script&lang=js&"
import style0 from "./Capillaries.vue?vue&type=style&index=0&id=5eaf2062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf2062",
  null
  
)

export default component.exports